import React from "react";

const ArrowRight = props => (
  <svg viewBox="0 0 11 16" fill="none" {...props}>
    <path
      d="M10.02 8.348a.828.828 0 000-1.16L3.2.332c-.352-.316-.88-.316-1.196 0l-.809.809c-.316.316-.316.843 0 1.195L6.61 7.75 1.195 13.2c-.316.35-.316.878 0 1.195l.809.808c.316.317.844.317 1.195 0l6.82-6.855z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowRight;
